<template>
  <div>
    <a-modal
      v-model="isShow"
      centered
      :width="1100"
      :mask-closable="false"
      title="导入短信模版"
      :ok-button-props="{ props: { loading: submitting } }"
      @ok="handleSubmit"
    >
      <import-sms-template-search @submit="submitSearch" />

      <a-table
        size="middle"
        :columns="tableColumns"
        :data-source="tableData"
        :loading="loading"
        :pagination="false"
        :scroll="{ y: 350 }"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        row-key="id"
      />

      <a-row class="count-tips">
        共 {{ this.tableData.length }} 条记录，已选中 {{ this.selectedRowKeys.length }} 条数据
      </a-row>
    </a-modal>
  </div>
</template>

<script>
import { importAgentsSmsTemplates } from '@/api/agents_sms_template'
import { findImportableSmsTemplates } from '@/api/sms_template'
import ImportSmsTemplateSearch from '@/views/agents_sms_templates/import/Search'

export default {
  name: 'ImportAgentsSmsTemplate',
  components: { ImportSmsTemplateSearch },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    agentId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      selectedRowKeys: [],
      query: {},
      submitting: false,
      tableColumns: [
        {
          title: '模版名称',
          fixed: 'left',
          dataIndex: 'name'
        },
        {
          title: '模版内容',
          dataIndex: 'content'
        },
        {
          title: '备注',
          dataIndex: 'remark'
        }
      ],
      tableData: []
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys
    },

    fetchData() {
      this.loading = true
      this.selectedRowKeys = []
      findImportableSmsTemplates(this.query).then((res) => {
        this.tableData = res.data
        this.loading = false
      })
    },

    submitSearch(search) {
      this.query = search
      this.fetchData()
    },

    handleSubmit() {
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }

      if (this.selectedRowKeys.length === 0) {
        this.$warning({
          title: '请选择操作对象',
          content: ''
        })
        return
      }

      const data = {
        agent_id: this.agentId,
        sms_template_ids: this.selectedRowKeys
      }

      this.submitting = true
      importAgentsSmsTemplates(data).then((res) => {
        if (res.code === 0) {
          // 关闭模态框
          this.isShow = false
          // 告知父组件已完成
          this.$emit('completed')
        }
        this.submitting = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.count-tips {
  padding-top: 20px;
}
</style>
